import { useAuth } from "@/context/AuthContext";
import { HardHat, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function EngineerProfile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/login", { replace: true }); };

  return (
    <div className="px-4 py-4">
      <div className="sharp-card p-6 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-md bg-primary/10 text-primary">
          <HardHat className="h-8 w-8" />
        </div>
        <h1 className="mt-3 font-heading text-xl font-bold">{user?.name}</h1>
        <p className="text-xs text-muted-foreground">{user?.email}</p>
        <p className="mt-1 text-[10px] uppercase tracking-widest text-muted-foreground">Field Engineer</p>
      </div>

      <button onClick={doLogout} className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md border border-destructive/40 bg-destructive/10 py-3 text-sm font-semibold text-destructive">
        <LogOut className="h-4 w-4" /> Sign out
      </button>
    </div>
  );
}
